import { BaseController } from '@Controller';
import { ExAxios } from '@ExAxios';
import g from '@global';
import axios from 'axios';
import QS from 'qs';
import { autobind } from 'core-decorators';
import Map from './Map.vue'; //  // ../../../routePage/main/Map.vue
import Service from '@/utils/request';

import HivesPoints from '../../../mainPage/mapComponents/HivesPoints.vue';
import Search from '../../../routePage/main/Search.vue'; // ../map/search/Search.vue
import Airline from '../../../routePage/main/Airline.vue';
import { displayDockTree } from '@/utils/common';
import DockApi from '@/api/flight/dock';

function getQueryString(name) {
    let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    let h = window.location.hash;
    let search = h.split('?')[1];
    let r = search.match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

const api = {
    getAirline(params) {
        return new ExAxios((config) => axios.get(`${g.getBaseServer('manage')}/route/info/getById`, {
            params,
            ...config,
        }));
    },
    saveAirLine(data) {
        return new ExAxios((config) => axios.post(`${g.getBaseServer('manage')}/route/info/save`, QS.stringify(data), {
            ...config,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }));
    },
    getCategory(params) {
        return new ExAxios((config) => axios.post(`${g.getBaseServer('manage')}/uav/geolayer/uavGeolayer/findPageList`, null, {
            params,
            ...config,
        }));
    },
    getNear(params) {
        return new ExAxios((config) => axios.get(`${g.getBaseServer('manage')}/uav/geofence/uavGeofence/findRangeList`, {
            params,
            ...config,
        }));
    },
    getSite(params) {
        return new ExAxios((config) => axios.get(`${g.getBaseServer('manage')}/site/info/findList`, {
            params,
            ...config,
        }));
    },

    getSiteInfo: (params) => Service.get('/fcs/site/list', params),
    getSiteList: (params) => Service.get('/fcs/site/list', params),
    getRouteList: (params) => Service.get('/fcs/route/list', {}),

    getRouteSave(params) {
        return new ExAxios((config) => axios.get(`${g.getBaseServer('manage')}/route/info/save`, {
            params,
            ...config,
        }));
    },
    getRouteDel(params) {
        return new ExAxios((config) => axios.get(`${g.getBaseServer('manage')}/route/info/deleteById`, {
            params,
            ...config,
        }));
    },
    getRouteToggleStatus(params) {
        return new ExAxios((config) => axios.get(`${g.getBaseServer('manage')}/route/info/toggleStatus`, {
            params,
            ...config,
        }));
    },
    //
};

@autobind
class AirlineController extends BaseController {
    constructor(MixMapModule) {
        super({});
        this.MixMapModule = MixMapModule;
    }

    static getsession() {
        return {
            center: {
                type: 'input',
                caller: 'toCenter',
            },
        };
    }

    static getConfig() {
        return {
            outputStyle: {
                position: 'absolute',
                top: '0px',
                left: '0px',
            },
        };
    }

    static getInput() {
        return {
            map: {
                renderFun: 'renderMap',
            },
            // videoList: {
            //     renderFun: 'renderVideoList',
            // },
        };
    }

    static getOutput(self) {
        return {
            map: {
                component: Map,
                attribute() {
                    return {
                        props: {
                            searchHive: self.vm.searchHive,
                            layers: self.vm.layers,
                            toXmlFile: self.toXmlFile,
                            RouteValue: self.vm.RouteValue,
                            renderMap: self.renderMap,
                        },
                        ref: 'map',
                    };
                },
            },

            // 站点组件
            HivesPoints: {
                component: HivesPoints,
                attribute() {
                    return {
                        props: {
                            hives: self.vm.hiveList, // 站点
                            clickable: false,
                        },
                    };
                },
            },
            // 航线组件
            // Airline: {
            //     component: Airline,
            //     attribute() {
            //         return {
            //             props: {
            //                 type: 'task',
            //                 searchHive: self.vm.searchHive,
            //                 SeeShow: self.vm.SeeShow,
            //                 RouteValue: self.vm.RouteValue,
            //                 airlineConfig: self.vm.airlineConfig,
            //                 lineType: self.vm.lineType,
            //             },
            //         };
            //     },
            // },
            search: {
                component: '',
                attribute() {
                    let attr = {
                        props: {
                            rightShow: self.vm.rightShow,
                            hiveList: self.vm.hiveList,
                            changeShowAddres: self.changeShowAddres,
                        },
                    };
                    return attr;
                },
            },
        };
    }

    static getVMConfig(config, instance) {
        return {
            data() {
                return {
                    SeeShow: false,
                    RouteValue: '',
                    rightShow: false,
                    hiveList: [],
                    searchHive: {},
                    routeList: [],
                    airline: {
                        routeName: '航线001',
                        routeType: 1,
                        routeCode: 'line001',
                        coordinates: '',
                        remark: '',
                    },
                    selectPointIndex: 0,
                    airT: 0,
                    center: null,
                    layers: [],
                    searchForm: {},
                };
            },
            computed: {
                selectPoint() {
                    if (!this.airlineConfig) return null;
                    if (!this.airlineConfig.points) return null;
                    return this.airlineConfig.points[this.selectPointIndex];
                },
            },
            async created() {
                // let siteList = await api.getSiteList();
                // this.hiveList = siteList.rows;
            },
        };
    }

    // 地图搜索
    changeShowAddres(addre) {
        this.MixMapModule.toCenter([Number(addre.longitude), Number(addre.latitude), 5000]);
    }

    toCenter(center) {
        this.vm.$refs.map.toCenter(center);
    }

    async getSiteList() {
        // let siteList = await api.getSiteList();
        DockApi.getDockTree().then((res) => {
            console.log(res);
            this.vm.hiveList = displayDockTree(res.data);
        });
        // this.vm.hiveList = siteList.rows;
        // console.log('this.vm.hiveList', this.vm.hiveList);
    }
}

export default AirlineController;
